import * as React from "react";
const SvgPositionY = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.9056 4H18.2762L13 12.2912V20H11L11 12.2912L5.72379 4H8.0944L12 10.1374L15.9056 4Z", fill: "currentColor" }));
export default SvgPositionY;
